export const DAILY_STREAK = {
  GET_STREAK_CONFIG: 'GET_STREAK_CONFIG',
}
